import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as AdminIndexActions from '../../../actions/admin/Index/adminIndexAction';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import autoBind from 'auto-bind';

let btnSize = { fontSize: '13' };
class EmailTemplateList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			emailTemplateList: [],
		}
	}

	componentWillMount() {
		let object = {
			templateId: this.props.match.params.templateId,
		}
		this.props.actions.getEmailTemplateById(object);
	}

	componentWillReceiveProps(nextProps) {
        console.log("++++++++++++++++++++>>>", nextProps)
		this.setState({
			emailTemplateList: nextProps.emailTemplateList,
		})
	}

	render() {
        var emailTemplateList = this.state.emailTemplateList
        console.log("sssss", emailTemplateList)
		return (
			<div className="content-wrapper" >
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link to="#tab_1" data-toggle="tab" className="active show">Email Template Details</Link></li>
										<li className=" col-md">
											<div className="content-header"><ol className="breadcrumb">
												<li><Link to="/user/email-templates"> Email Templates</Link></li>
												<li className="active">Email Template Details</li>
											</ol></div>
										</li>
									</ul>
									<div className="tab-content">
										<form className="appointmentDetaile-form" id="appointmentDetaileForm" >
											<div className="tab-pane active" id="tab_1">
												<div className="settingInput appointmentBox">
													<div className="row">
														<div className="col-md-12">
															<div className="row">
																<div className="col-md-2">
																	<div className="genderInfo ">Subject</div>
																</div>
																<div className="col-md-10">
																	<div className="boxMrgB boxMrgT">
																		{emailTemplateList.subject}
																	</div>
																</div>
															</div>
														</div>
														<div className="col-md-12">
															<div className="row">
																<div className="col-md-2">
																	<div className="genderInfo ">Description</div>
																</div>
																<div className="col-md-10">
																	<div className="boxMrgB boxMrgT">
																		<p dangerouslySetInnerHTML={{ __html: emailTemplateList.description }}></p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div >
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		emailTemplateList: state.adminUser.emailTemplates ? state.adminUser.emailTemplates : [],
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateList);